



















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Utilities as utils } from "@/shared/utilities";
import "@/styles/iucn/timeline.css";
import RowItem from "./TimelineComponents/RowItem.vue";

@Component({
  components: {
    RowItem
  }
})
export default class ProjectTimelineComponent extends Vue {
  @Prop() appData!: any;
  @Prop() readOnly: boolean;
  @Getter("projectYrs", { namespace: "conceptNote" }) years: any;
  @Getter("reportingFrequency", { namespace: "conceptNote" }) reportingFreq: any;
  logKey: number = 0;
  
  get timeFrame() {
    return this.reportingFreq;
  }

  section(frame: any) {
    if (this.timeFrame === 2) {
      switch (frame) {
        case 1:
          return this.$t('1st Half');
          break;
        case 2:
          return this.$t('2nd Half');
          break;
      }
    } else if (this.timeFrame === 4) {
      switch (frame) {
        case 1:
          return `${this.$t('Q')}1`;
          break;
        case 2:
          return `${this.$t('Q')}2`;
          break;
        case 3:
          return `${this.$t('Q')}3`;
          break;
        case 4:
          return `${this.$t('Q')}4`;
          break;
      }
    }
  }
}
